// frontend/pages/AdminVendorPurchases.js
import React, { useEffect, useState } from "react";
import API from "../utils/api";

const AdminVendorPurchases = () => {
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const fetchPurchases = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await API.get("/admin/vendor-purchases");
      setPurchases(res.data || []);
    } catch (err) {
      setError("❌ Failed to fetch vendor purchases.");
      console.error("Failed to fetch vendor purchases", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPurchases();
  }, []);

  const handleAction = async (id, action) => {
    try {
      setMessage("");
      await API.post(`/admin/vendor-purchases/${id}/${action}`);
      setMessage(
        action === "approve"
          ? "✅ Purchase approved and vendor credited"
          : "❌ Purchase rejected"
      );
      fetchPurchases();
    } catch (err) {
      setError(`❌ Failed to ${action} purchase.`);
      console.error(`Failed to ${action} purchase`, err);
    }
  };

  if (loading) return <p className="text-white">Loading vendor purchases...</p>;

  return (
    <div className="p-6 bg-gray-900 text-white min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Vendor Purchase Requests</h1>

      {error && <p className="text-red-400 mb-4">{error}</p>}
      {message && <p className="text-green-400 mb-4">{message}</p>}

      {purchases.length === 0 ? (
        <p className="text-gray-400">No pending purchases.</p>
      ) : (
        purchases.map((p) => (
          <div
            key={p._id}
            className="bg-gray-800 p-4 mb-4 rounded-lg shadow border border-gray-700 flex justify-between items-center"
          >
            <div>
              <p className="font-bold text-lg">{p.vendor?.name}</p>
              <p className="text-sm text-gray-400">📧 {p.vendor?.email}</p>
              <p className="text-sm">💰 Amount: ₦{Number(p.amount).toLocaleString()}</p>
              <p className="text-sm">🏦 Source: {p.source || "Bank Transfer"}</p>
              <p
                className={`text-sm font-semibold ${
                  p.status === "pending"
                    ? "text-yellow-400"
                    : p.status === "approved"
                    ? "text-green-400"
                    : "text-red-400"
                }`}
              >
                ⏳ Status: {p.status}
              </p>
            </div>

            {p.status === "pending" && (
              <div className="flex gap-2">
                <button
                  onClick={() => handleAction(p._id, "approve")}
                  className="bg-green-600 hover:bg-green-700 px-3 py-1 rounded"
                >
                  Approve
                </button>
                <button
                  onClick={() => handleAction(p._id, "reject")}
                  className="bg-red-600 hover:bg-red-700 px-3 py-1 rounded"
                >
                  Reject
                </button>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default AdminVendorPurchases;
